import { Spacing } from '../../primitives/spacing.js';

const ELEMENT = 'div';
const CardDefaultElement = ELEMENT;
const paddingTypes = {
  none: 0,
  sm: Spacing.scale[2],
  md: Spacing.scale[3]
};

export { CardDefaultElement, paddingTypes };
